import McMap from './mc-map';

export default McMap;